import { post, get, patch, deleteRequest } from './restApi';

export const getQrCodeSetting = (payload) => {
    return get('qr-code-setting/get-setting', { ...payload });
}
export const updateQrCodeSetting = (payload) => {
    return patch('qr-code-setting/update', { ...payload });
}